import { render, staticRenderFns } from "./AppCopiableField.vue?vue&type=template&id=00367d0c&"
import script from "./AppCopiableField.vue?vue&type=script&lang=js&"
export * from "./AppCopiableField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports